import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, getConfig } from "../../../../utils";

const toDate = (date) => {
    if (!date) return ''
    const parsed = moment(date, 'DD/MM/YYYY')
    return parsed.isValid() ? parsed.format('YYYY-MM-DD') : ''
}

export const updateMasterCoupon = createAsyncThunk('updateMasterCoupon', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'update_coupon',
            data: {
                "id": data?.values?.id,
                "coupon_code": data?.values?.couponCode,
                "start_date": toDate(data?.values?.startDate),
                "end_date": toDate(data?.values?.endDate),
                "count": Number(data?.values?.count),
                "user_per_count": Number(data?.values?.userPerCount),
                "discount_type": data?.values?.discountType,
                "discount_value": Number(data?.values?.discountValue),
                "paid_type": data?.values?.paidType,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})
